import React from 'react'
import styled from '@emotion/styled'

import SEO from '~/components/seo'
import ProductGrid from '~/components/ProductGrid'
import Introduction from '~/components/Introduction'

import { breakpoints } from '~/utils/styles'

const ShopPage = () => {
  return (
    <>
      <SEO title="Shop" />
      <Padding>
        <Introduction title="Shop <span>Nooro</span>" />
        <ProductGrid />
      </Padding>
    </>
  )
}

export default ShopPage

const Padding = styled.div`
  padding-top: 100px;

  @media (max-width: ${breakpoints.s}px) {
    padding-top: 50px 0 !important;
  }
`
